export default "__VITE_ASSET__4b20a955__"